import { TableEmptyState } from '@practium/ui';
import type { SoilAnalysis } from '../../../types/analyses.types';
import { BRAZILIAN_STATES } from '../../../constants/analyses.constants';
import { formatIsoDate, resolveLabel } from '../../../utils/analysisFormatters';
import styles from '../AnalysesTable.module.css';

interface SoilAnalysisTableProps {
	analyses: SoilAnalysis[];
	onRowClick?: (id: string) => void;
}

const STATUS_CLASS: Record<string, string> = {
	Pendente: styles.statusPending,
	Realizada: styles.statusDone,
	'A vencer': styles.statusUpcoming,
};

export const SoilAnalysisTable = ({ analyses, onRowClick }: SoilAnalysisTableProps) => {
	if (analyses.length === 0) {
		return (
			<TableEmptyState
				title="Nenhuma análise de solo encontrada"
				subtitle="Adicione uma nova análise para visualizá-la aqui"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome da Amostra</th>
						<th>Estado</th>
						<th>Data da Coleta</th>
						<th>Propriedade</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{analyses.map((analysis) => (
						<tr
							key={analysis._id}
							onClick={() => onRowClick?.(analysis._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{analysis.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{analysis.state ? resolveLabel(BRAZILIAN_STATES, analysis.state) : '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{formatIsoDate(analysis.sampledAt)}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{analysis.property ?? '—'}</span>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${STATUS_CLASS[analysis.status] ?? ''}`}
								>
									{analysis.status}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
